const Page404 = () => {
  return (
    <div className="notfound__container">
      <h2> OUT 404 </h2>
      <p>Page not found</p>
    </div>
  );
};
export default Page404;
